import { Plus, X } from 'lucide-react';

import { DocStarIcon } from 'components/blocks/layout/doc-star-icon';
import { cn } from 'lib/utils';
import type { MentionPickerItem } from 'features/chat/utils/normalize-mention-search';

type SelectedSkillChipsProps = {
  skills: MentionPickerItem[];
  onRemove: (skillId: string) => void;
  onAddClick: () => void;
  className?: string;
};

export function SelectedSkillChips({
  skills,
  onRemove,
  onAddClick,
  className,
}: SelectedSkillChipsProps) {
  if (skills.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-2 border-b border-border/50 pb-3 mb-3',
        className
      )}
    >
      {skills.map((skill) => (
        <div
          key={skill.id}
          className="inline-flex max-w-full items-center gap-1.5 rounded-full border border-border/70 bg-muted/50 py-1 pl-1.5 pr-1 text-sm text-foreground"
        >
          <span className="flex h-5 w-5 shrink-0 items-center justify-center overflow-hidden rounded-full bg-background">
            {skill.iconUrl ? (
              <img src={skill.iconUrl} alt="" className="h-full w-full object-cover" />
            ) : (
              <DocStarIcon className="h-3.5 w-3.5" />
            )}
          </span>
          <span className="truncate font-medium">{skill.title}</span>
          <button
            type="button"
            className="ml-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            aria-label={`Remove ${skill.title}`}
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onRemove(skill.id)}
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      ))}

      <button
        type="button"
        className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-dashed border-border text-muted-foreground transition-colors hover:border-foreground/40 hover:bg-muted/50 hover:text-foreground"
        aria-label="Add skill"
        onMouseDown={(event) => event.preventDefault()}
        onClick={onAddClick}
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
}
